import React from 'react';
import { FiActivity, FiArrowRight, FiArrowDown } from 'react-icons/fi';

const TemperatureStability = () => {
  return (
    <div className="w-full max-w-sm bg-white border border-gray-100 rounded-2xl p-5 font-sans shadow-[0_2px_12px_rgba(0,0,0,0.01)] flex flex-col justify-between min-h-[360px] select-none">
      <div>
        {/* Title Bar */}
        <div className="flex items-center gap-2 mb-4">
          <FiActivity className="w-4 h-4 text-blue-500" />
          <h3 className="text-[15px] font-bold text-gray-800 tracking-tight">
            Temperature Stability
          </h3>
        </div>

        {/* Circular SVG Percentage Ring Layout Graphic */}
        <div className="flex items-center gap-5 mb-6">
          <div className="relative w-18 h-18 shrink-0">
            <svg className="w-[100px] h-auto transform -rotate-90" viewBox="0 0 36 36">
              <path className="text-gray-100" strokeWidth="3" stroke="currentColor" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
              {/* 98% Gauge Fill Path fill */}
              <path className="text-emerald-500" strokeDasharray="98, 100" strokeWidth="3" strokeLinecap="round" stroke="currentColor" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-[16px] font-black text-gray-900 tracking-tighter">98%</span>
            </div>
          </div>
          <div className="space-y-0.5">
            <h4 className="text-[15px] font-extrabold text-emerald-600 leading-none">Excellent</h4>
            <p className="text-[11px] font-semibold text-gray-400">Very stable</p>
          </div>
        </div>

        {/* Comparison Metadata Lower Section Rows */}
        <div className="grid grid-cols-2 gap-3 border-t border-gray-50 pt-4">
          <div className="bg-[#FAF9F6]/60 border border-gray-100/60 rounded-xl p-2.5">
            <span className="text-[10px] font-bold text-gray-400 block mb-1">Variance (Today)</span>
            <span className="text-[13px] font-black text-gray-800">±0.6°C</span>
          </div>
          <div className="bg-[#FAF9F6]/60 border border-gray-100/60 rounded-xl p-2.5">
            <span className="text-[10px] font-bold text-gray-400 block mb-1">Compared to yesterday</span>
            <div className="flex items-center gap-0.5 text-emerald-600 text-[13px] font-black">
              <FiArrowDown className="w-3.5 h-3.5 stroke-[3]" />
              <span>8% better</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Footer */}
      <button className="w-full flex items-center justify-between text-[#0052FF] font-bold text-[12px] hover:opacity-80 transition-opacity border-t border-gray-50 pt-4 mt-6 group cursor-pointer">
        <span>View stability analysis</span>
        <FiArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 stroke-[2.5]" />
      </button>
    </div>
  );
};

export default TemperatureStability;
